module.exports = __webpack_public_path__ + "img/73.2.TN.100c1533.png";